module.exports = __webpack_public_path__ + "static/media/Checkout-1.41282ff6.png";